angular.module('env.log', [

    'env.log.omLogger',
    'env.log.logDecorator'

]);
